
import React      from 'react';
import CSSModules from 'react-css-modules';

import classNames from 'classnames/bind';

import style from './style.scss';

class FontIcon extends React.Component {

    _getMimeGroup(mimeType) {

        return mimeType.split('/')[0];
    }

    _mimeTypeToIconName(mimeType) {

        const mappings = {
            'image': 'fa-file-image-o',
            'audio': 'fa-file-audio-o',
            'video': 'fa-file-video-o',
            'application/pdf': 'fa-file-pdf-o',
            'text/plain': 'fa-file-text-o',
            'text/html': 'fa-file-code-o',
            'application/json': 'fa-file-code-o',
            'application/gzip': 'fa-file-archive-o',
            'application/zip': 'fa-file-archive-o',
            'application/octet-stream': 'fa-file-o'
        };

        if (mappings[mimeType]) {

            return mappings[mimeType];

        } else {

            const mimeGroup = this._getMimeGroup(mimeType);

            if (mappings[mimeGroup]) {

                return mappings[mimeGroup];
            }
        }

        return 'fa-file-o';
    }

    _getIconClassName() {

        var cx = classNames.bind(style);

        var classes = {
            'icon': true,
            'fa': true
        };

        if (typeof this.props.mimeType !== 'undefined') {

            const mimeIcon = this._mimeTypeToIconName(this.props.mimeType);

            classes[mimeIcon] = true;

        } else {

            classes['fa-' + this.props.iconName] = true;
        }

        if (this.props.className) {

            classes[this.props.className] = true;
        }

        return cx(classes);
    }

    _getContainerClassName() {

        var cx = classNames.bind(style);

        var classes = {
            'button-icon': this.props.isButtonIcon,
            'right-text': this.props.textPosition === 'right',
            'left-text': this.props.textPosition === 'left',
            'stacked-icon': true
        };

        if (this.props.className) {

            classes[this.props.className] = true;
        }

        return cx(classes);
    }

    render() {

        return (

            <span className={ this._getContainerClassName() }>
                <i className={ this._getIconClassName() } />
                { this.props.children }
            </span>
        );
    }
}

export default CSSModules(FontIcon, style);


// WEBPACK FOOTER //
// ./components/FontIcon/index.js